<template>
  <div class="chawgt-webchat-msg chawgt-webchat-msg-right"
       :class="getClasses(content)" :style="getStyle(content)" >
    {{ content.item.label }}
    <span class="chawget-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'

export default {
  name: 'ContentChoosed',
  extends: BaseMessage
}

</script>

<style lang="scss" scoped>
div {
  font-weight: bold;
}
</style>
